import React, { useEffect, useState, useContext } from "react";
import { FormGroup, Col } from "reactstrap";
import {
  DatePicker,
  TextField,
  Radio,
  Button,
  MessageAlert,
  Dropdown,
} from "../../../components/Components";
import { formDataContext } from "../BillingDetail";
import "./HeadDetail.css";
import { useTranslation } from "react-i18next";
import { FaArrowLeftLong } from "react-icons/fa6";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";

const HeadDetail = () => {
  const { getBillingRq, getBillingRs, isModal, isHideTitle, statusList } =
    useContext(formDataContext);

  const { t } = useTranslation();
  let navigate = useNavigate();

  const TextDetail = ({ title, value, titleWidth, color, valueWidth }) => (
    <div style={{ width: "100%", color: color ?? "black" }}>
      <Grid container style={{ display: "flex" }}>
        <Grid style={{ width: titleWidth ?? "30%", textAlign: "right" }}>
          <span style={{ fontWeight: "bold" }}>{`${title} :`}</span>
        </Grid>
        <Grid
          style={{
            width: valueWidth ?? "auto",
            marginLeft: "15px",
            textAlign: "right",
          }}
        >
          <span>{`${value}`}</span>
        </Grid>
      </Grid>
    </div>
  );

  const getBillingStatusDesc = (status) => {
    let statusDesc =
      statusList?.find((item) => item.configValue === status)?.configDesc ??
      t("NotSummaryBillingStatus");

    return statusDesc;
  };

  return (
    <>
      <div className="ShearchContainer" style={{ display: "flex" }}>
        {isModal ? (
          <></>
        ) : (
          <div className="ShearchDetailComponent">
            <FaArrowLeftLong
              style={{
                height: "25px",
                width: "25px",
                marginTop: "2px",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(-1);
              }}
            />
          </div>
        )}
        <div style={{ width: "100%" }}>
          {!isHideTitle && (
            <div className="ShearchDetailComponent">
              <span className="textHeader">{t("BillingDetail")}</span>
            </div>
          )}

          <div className="ShearchDetailComponent">
            <Grid container style={{ gap: "15px" }}>
              <Grid style={{ flexGrow: "1" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <TextDetail
                    title={t("BillingSummaryNo")}
                    value={getBillingRq?.lotno ?? getBillingRq?.advno}
                    titleWidth={"auto"}
                  />
                  <TextDetail
                    title={t("HeaderTableBillingType")}
                    value={
                      getBillingRs?.billingType === "S"
                        ? t("BillingTypeSpecial")
                        : t("BillingTypeNormal")
                    }
                    titleWidth={"auto"}
                  />
                  <TextDetail
                    title={t("BillingStatus")}
                    value={getBillingStatusDesc(getBillingRs?.billingStatus)}
                    titleWidth={"auto"}
                  />
                </div>
              </Grid>
              <Grid style={{ flexGrow: "1" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  <TextDetail
                    title={t("Income")}
                    value={`${Number(getBillingRs?.totalIncome)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${t("Bath")}`}
                    valueWidth={"40%"}
                  />
                  <TextDetail
                    title={`${t("ProcessingFee")}`}
                    value={`${Number(getBillingRs?.tradeDiscount)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${t("Bath")}`}
                    color={"red"}
                    valueWidth={"40%"}
                  />
                  <TextDetail
                    title={t("EstimatedIncome")}
                    value={`${Number(getBillingRs?.estimateIncome)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${t("Bath")}`}
                    color={"#03C04A"}
                    valueWidth={"40%"}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeadDetail;
